// extracted by mini-css-extract-plugin
export default {"container":"Product_container__48E0l","products":"Product_products__y9Ilm","menu":"Product_menu__QXvc8","list":"Product_list__Acbad","product":"Product_product__Y8F2H"};